import { Fragments } from "requests";
import {
  GENERAL_ASSESSMENT_ARRAY_VALUED_KEYS,
  GENERAL_ASSESSMENT_KEYS
} from "./constants";

export const hasDentalChartingData = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => {
  if (!generalAssessment) {
    return false;
  }

  const hasGeneralAssessmentData =
    GENERAL_ASSESSMENT_KEYS.some(
      key => generalAssessment[key] != null && generalAssessment[key] !== ""
    ) ||
    GENERAL_ASSESSMENT_ARRAY_VALUED_KEYS.some(
      key => generalAssessment[key].length > 0
    ) ||
    generalAssessment.boneAugmentation;

  return hasGeneralAssessmentData;
};

export const hasTPLOData = (tplo: Fragments.StoredTPLO) => {
  if (!tplo) {
    return false;
  }

  const tploKeys = [
    "d1",
    "d2",
    "d3",
    "rotationNeeded",
    "initialTpa",
    "postOpTpa",
    "tploBladeSize",
    "tploPlateSizeAndModel"
  ] as (keyof Fragments.StoredTPLO)[];

  return tploKeys.some(key => tplo[key] !== null && tplo[key] !== "");
};
